import { render, staticRenderFns } from "./pw_confirm.vue?vue&type=template&id=7e12c2be&scoped=true&"
import script from "./pw_confirm.vue?vue&type=script&lang=js&"
export * from "./pw_confirm.vue?vue&type=script&lang=js&"
import style0 from "./pw_confirm.vue?vue&type=style&index=0&id=7e12c2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12c2be",
  null
  
)

export default component.exports